"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userWorkspacePermissionsDataLoaderFactory = exports.dateDatasetsDataLoaderFactory = exports.dashboardDataLoaderFactory = exports.dashboardAlertsDataLoaderFactory = exports.attributesWithDrillDownDataLoaderFactory = exports.userWorkspaceSettingsDataLoaderFactory = exports.insightDataLoaderFactory = exports.colorPaletteDataLoaderFactory = exports.clearDashboardViewCaches = exports.clearInsightViewCaches = void 0;
var ColorPaletteDataLoader_1 = require("./ColorPaletteDataLoader");
Object.defineProperty(exports, "colorPaletteDataLoaderFactory", { enumerable: true, get: function () { return ColorPaletteDataLoader_1.colorPaletteDataLoaderFactory; } });
var InsightDataLoader_1 = require("./InsightDataLoader");
Object.defineProperty(exports, "insightDataLoaderFactory", { enumerable: true, get: function () { return InsightDataLoader_1.insightDataLoaderFactory; } });
var UserWorkspaceSettingsDataLoader_1 = require("./UserWorkspaceSettingsDataLoader");
Object.defineProperty(exports, "userWorkspaceSettingsDataLoaderFactory", { enumerable: true, get: function () { return UserWorkspaceSettingsDataLoader_1.userWorkspaceSettingsDataLoaderFactory; } });
var AttributesWithDrillDownDataLoader_1 = require("./AttributesWithDrillDownDataLoader");
Object.defineProperty(exports, "attributesWithDrillDownDataLoaderFactory", { enumerable: true, get: function () { return AttributesWithDrillDownDataLoader_1.attributesWithDrillDownDataLoaderFactory; } });
var DashboardAlertsDataLoader_1 = require("./DashboardAlertsDataLoader");
Object.defineProperty(exports, "dashboardAlertsDataLoaderFactory", { enumerable: true, get: function () { return DashboardAlertsDataLoader_1.dashboardAlertsDataLoaderFactory; } });
var DashboardDataLoader_1 = require("./DashboardDataLoader");
Object.defineProperty(exports, "dashboardDataLoaderFactory", { enumerable: true, get: function () { return DashboardDataLoader_1.dashboardDataLoaderFactory; } });
var DateDatasetsDataLoader_1 = require("./DateDatasetsDataLoader");
Object.defineProperty(exports, "dateDatasetsDataLoaderFactory", { enumerable: true, get: function () { return DateDatasetsDataLoader_1.dateDatasetsDataLoaderFactory; } });
var UserWorkspacePermissionsDataLoader_1 = require("./UserWorkspacePermissionsDataLoader");
Object.defineProperty(exports, "userWorkspacePermissionsDataLoaderFactory", { enumerable: true, get: function () { return UserWorkspacePermissionsDataLoader_1.userWorkspacePermissionsDataLoaderFactory; } });
/**
 * Clears all the caches used by the InsightView components.
 *
 * @public
 */
function clearInsightViewCaches() {
    var relevantFactories = [
        ColorPaletteDataLoader_1.colorPaletteDataLoaderFactory,
        InsightDataLoader_1.insightDataLoaderFactory,
        UserWorkspaceSettingsDataLoader_1.userWorkspaceSettingsDataLoaderFactory,
    ];
    relevantFactories.forEach(function (factory) { return factory.reset(); });
}
exports.clearInsightViewCaches = clearInsightViewCaches;
/**
 * Clears all the caches used by the DashboardView components.
 *
 * @beta
 */
function clearDashboardViewCaches() {
    var relevantFactories = [
        AttributesWithDrillDownDataLoader_1.attributesWithDrillDownDataLoaderFactory,
        ColorPaletteDataLoader_1.colorPaletteDataLoaderFactory,
        DashboardAlertsDataLoader_1.dashboardAlertsDataLoaderFactory,
        DashboardDataLoader_1.dashboardDataLoaderFactory,
        DateDatasetsDataLoader_1.dateDatasetsDataLoaderFactory,
        InsightDataLoader_1.insightDataLoaderFactory,
        UserWorkspacePermissionsDataLoader_1.userWorkspacePermissionsDataLoaderFactory,
        UserWorkspaceSettingsDataLoader_1.userWorkspaceSettingsDataLoaderFactory,
    ];
    relevantFactories.forEach(function (factory) { return factory.reset(); });
}
exports.clearDashboardViewCaches = clearDashboardViewCaches;
//# sourceMappingURL=index.js.map